import { render, staticRenderFns } from "./EditParkingOccupancyDialog.vue?vue&type=template&id=0c64cf27&scoped=true"
import script from "./EditParkingOccupancyDialog.vue?vue&type=script&lang=js"
export * from "./EditParkingOccupancyDialog.vue?vue&type=script&lang=js"
import style0 from "./EditParkingOccupancyDialog.vue?vue&type=style&index=0&id=0c64cf27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c64cf27",
  null
  
)

export default component.exports